import React, { useEffect, useState } from 'react';
import styles from './ProgressCircleV2.css';

function ProgressCircleV2({ radius = 50, score, maxScore, color = 'var(--error-light-color)', bgColor }) {
    const circumference = 2 * Math.PI * radius;
    const progress = Math.round(((score || 1) / maxScore) * 100);
    const [offset, setOffset] = useState(circumference);
    const [displayedScore, setDisplayedScore] = useState(0);

    useEffect(() => {
        const progressOffset = circumference - (progress / 100) * circumference;

        setTimeout(() => setOffset(progressOffset), 50);

        let current = 0;
        const duration = 2000;
        const stepTime = 100;
        const step = score / (duration / stepTime);

        const interval = setInterval(() => {
            current += step;

            if (current >= score) {
                current = score;
                clearInterval(interval);
            }
            setDisplayedScore(Math.round(current));
        }, stepTime);

        return () => clearInterval(interval);
    }, [progress, circumference, score]);

    const containerStyle = {
        '--current-color': color,
        ...(bgColor ? { '--circle-bg-color': bgColor } : {})
    };

    return (
        <div className={styles.progressContainer} style={containerStyle}>
            <svg width={112} height={112}>
                <circle
                    cx={56}
                    cy={56}
                    r={radius}
                    className={styles.circleBg}
                />
                <circle
                    cx={56}
                    cy={56}
                    r={radius}
                    className={styles.circle}
                    style={{
                        strokeDasharray: circumference,
                        strokeDashoffset: offset
                    }}
                />
            </svg>
            <p className={styles.progressText}>{displayedScore}/{maxScore}</p>
        </div>
    );
}

export {
    ProgressCircleV2
};
